/**
 * Returns a user-friendly error message from an API response.
 * @param {object} data - Parsed JSON body (may have message, error, details)
 * @param {number} status - HTTP status code
 * @param {object} fallbacks - Optional { 400?, 401?, 404?, 500?, default? } for custom messages
 * @returns {string}
 */
export function getApiErrorMessage(data, status, fallbacks = {}) {
  const msg = data?.message || data?.error || (typeof data?.details === 'string' ? data.details : null);
  if (msg && String(msg).trim()) return String(msg).trim();
  const statusFallbacks = {
    400: fallbacks[400] ?? 'Please check your input and try again.',
    401: fallbacks[401] ?? 'Your session may have expired. Please log in again.',
    403: fallbacks[403] ?? 'You don’t have permission to do this.',
    404: fallbacks[404] ?? 'The requested item was not found.',
    500: fallbacks[500] ?? 'Something went wrong on our end. Please try again later.',
    default: fallbacks.default ?? 'Something went wrong. Please try again.',
  };
  return statusFallbacks[status] || statusFallbacks.default;
}
